/**
 * Components
 */

import GMap from '../../shared/components/gmap/gmap';
import NumberedSlider from './custom/numbered-slider/numbered-slider';
import Table from './overwrites/shared/table/table';
import TmSlider from "./custom/tm-slider/tm-slider";

// ------
// Public
// ------

const components = () => {
	Table.makeScrollable();

	// const gMapAllowed = (typeof window.ifabCookieConsent !== 'undefined') ? window.ifabCookieConsent.getConsent('googlemaps') : true;
	//
	// if (gMapAllowed && typeof window.pageInstance.settings.maps.google.id) {
	GMap.init(null, {
		apiKey  : window.pageInstance.settings.maps.google.id,
		settings: {
			// Siehe google-maps.js -> DEFAULTS
			map: {
				zoom: 14
			}
		}
	});
	// }

	NumberedSlider.init();
	TmSlider.init();
};

// Export
export default components;
